<template>
  <!--Project Create Form-->
  <b-form @submit="onSubmit">
    <!--Name -->
    <b-form-group
      id="input-group-title"
      label="Project Title:"
      label-for="input-title"
    >
      <b-form-input
        id="input-title"
        v-model="form.projectTitle"
        placeholder="Enter Project Title"
        autofocus
        required
      ></b-form-input>
    </b-form-group>

    <!--Description-->
    <b-form-group
      id="input-group-description"
      label="Project Description:"
      label-for="input-description"
    >
      <b-form-textarea
        id="input-description"
        v-model="form.projectDescription"
        placeholder="Enter Project Description"
        required
      ></b-form-textarea>
    </b-form-group>

    <!--Priority-->
    <b-form-group
      id="input-group-priority"
      label="Project Priority:"
      label-for="input-priority"
    >
      <b-form-input
        id="input-priority"
        v-model="form.projectPriority"
        placeholder="Enter Priority"
        required
      ></b-form-input>
    </b-form-group>

    <!--Status-->
    <b-form-group
      id="input-group-status-id"
      label="Project Status:"
      label-for="input-status"
    >
      <b-form-select
        id="input-status-id"
        v-model="form.projectStatusId"
        :options="getProjectStatusList"
        value-field="id"
        text-field="status_name"
        required
      ></b-form-select>
    </b-form-group>

    <!--Category-->
    <b-form-group
      id="input-group-category-id"
      label="Project category:"
      label-for="input-category"
    >
      <b-form-select
        id="input-category-id"
        v-model="form.projectCategoryId"
        :options="getProjectCategoryList"
        value-field="id"
        text-field="category_name"
        required
      ></b-form-select>
    </b-form-group>

    <!--Platform-->
    <b-form-group
      id="input-group-platform-id"
      label="Project Platform:"
      label-for="input-platform-id"
    >
      <b-form-checkbox-group
        id="input-platform-id"
        v-model="form.projectPlatformId"
        :options="getProjectPlatformList"
        value-field="id"
        text-field="platform_name"
      ></b-form-checkbox-group>
    </b-form-group>

    <!--Submit Action-->
    <b-button-toolbar>
      <b-button type="submit" variant="success">Submit</b-button>
      <b-button variant="secondary" @click="closeModal($event.target)"
        >Cancel</b-button
      >
    </b-button-toolbar>
  </b-form>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "AddProjectForm",
  props: ["modalId"],
  data() {
    return {
      form: {
        projectTitle: "",
        projectDescription: "",
        projectPriority: 0,
        projectStatus: null,
        projectCategory: null,
        projectPlatform: [],
        projectStatusId: null,
        projectCategoryId: null,
        projectPlatformId: [],
      },
      show: true,
    };
  },

  computed: {
    ...mapGetters([
      "getToken",
      "getProjects",
      "getProjectPlatformList",
      "getProjectCategoryList",
      "getProjectStatusList",
      "getLanguages",
    ]),
  },

  methods: {
    ...mapActions([
      "addProjects",
      "showLoadingProcess",
      "closeLoading",
      "fetchProjectList",
    ]),

    async onSubmit(evt) {
      evt.preventDefault();
      let localeNameJson = {};
      let localeDescriptionJson = {};
      this.getLanguages.forEach((item) => {
        localeNameJson[item["language_code"]] = this.form.projectTitle;
        localeDescriptionJson[
          item["language_code"]
        ] = this.form.projectDescription;
      });
      this.getProjectCategoryList.forEach((item) => {
        if (item["id"] !== this.form.projectCategoryId) return;
        this.form.projectCategory = item["category_name"];
      });
      this.getProjectStatusList.forEach((item) => {
        if (item["id"] !== this.form.projectStatusId) return;
        this.form.projectStatus = item["status_name"];
      });
      this.form.projectPlatformId.forEach((platform) => {
        this.getProjectPlatformList.forEach((item) => {
          if (item["id"] !== platform) return;
          this.form.projectPlatform.push(item["platform_name"]);
        });
      });
      await this.showLoadingProcess();
      try {
        await this.addProjects({
          project_name: this.form.projectTitle,
          project_name_locale: localeNameJson,
          project_description: this.form.projectDescription,
          project_description_locale: localeDescriptionJson,
          project_priority: this.form.projectPriority,
          project_status: this.form.projectStatus,
          project_status_id: this.form.projectStatusId,
          project_category: this.form.projectCategory,
          project_category_id: this.form.projectCategoryId,
          project_platform: this.form.projectPlatform,
          project_platform_id: this.form.projectPlatformId,
        });
        this.$bvModal.hide(this.modalId);
      } catch (err) {
        console.log(err);
      } finally {
        await this.closeLoading();
      }
    },

    closeModal() {
      this.$bvModal.hide(this.modalId);
    },
  },
};
</script>
